module.exports = __webpack_public_path__ + "static/media/becca-lee-resume.062e7a48.pdf";